import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { PROCESS } from "../data/site";

export default function HowWeWork() {
  return (
    <section className="relative overflow-hidden bg-[#07111F] py-24 md:py-32 grain" data-testid="how-we-work-section">
      <div className="pointer-events-none absolute -left-40 top-0 h-[30rem] w-[30rem] rounded-full opacity-20 blur-3xl accent-bg" />
      <div className="container-x relative">
        <SectionHeading eyebrow="How we work" title="A clear path from idea to impact." dark max="max-w-2xl" />

        <div className="mt-16">
          {/* connector line desktop */}
          <div className="relative">
            <div className="absolute left-0 right-0 top-7 hidden h-px bg-white/10 lg:block" />
            <div className="grid gap-10 lg:grid-cols-4">
              {PROCESS.map((step, i) => {
                const Icon = step.icon;
                return (
                  <motion.div
                    key={step.n}
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                    className="relative flex gap-5 lg:block"
                    data-testid={`process-step-${i}`}
                  >
                    <div className="relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-2xl border border-white/10 bg-[#0B1220] text-cyan-300">
                      <Icon size={22} strokeWidth={1.8} />
                    </div>
                    <div className="lg:mt-6">
                      <span className="font-mono text-xs text-slate-500">{step.n}</span>
                      <h3 className="mt-1 font-display text-xl font-medium text-white">{step.title}</h3>
                      <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-400">{step.desc}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
